export default (
  state = {
    pageToDisplay: "NOW",
  },
  action,
) => {
  switch (action.type) {
    case 'SET_PAGE_TO_DISPLAY':
      return {
        ...state,
        pageToDisplay: action.pageToDisplay,
      }
    default:
      return state
  }
}